import { api } from './client'

// MOCK-ONLY API — the real backend has no payout ledger yet; these
// endpoints exist only in backend-mock (routes/payouts.ts). Wire types
// live here (not in types.ts) until the real BE grows a counterpart.

export type PayoutStatus = 'pending_review' | 'approved' | 'paid'

export interface PayoutRecord {
  id: number
  teamId: number
  userId: number
  periodStart: string
  periodEnd: string
  computedAmount: number
  approvedAmount: number | null
  status: PayoutStatus
  approvedBy: { id: number; firstName: string; lastName: string } | null
  approvedAt: string | null
  paidAt: string | null
  note: string | null
}

export interface ApprovePayoutsRequest {
  periodStart: string
  periodEnd: string
  items: Array<{ userId: number; approvedAmount: number; note?: string }>
}

export const payoutsApi = {
  // GET /teams/:teamId/payouts?userId= — team ledger, optional advisor filter.
  list: (teamId: number, userId?: number) =>
    api.get<PayoutRecord[]>(`/teams/${teamId}/payouts`, { userId }),

  // POST /teams/:teamId/payouts/approve — upserts one record per item
  // (keyed teamId+userId+periodStart) to 'approved'. Returns the records.
  approve: (teamId: number, data: ApprovePayoutsRequest) =>
    api.post<PayoutRecord[]>(`/teams/${teamId}/payouts/approve`, data),

  // PATCH /payouts/:id — status transition; 'paid' stamps paidAt.
  updateStatus: (payoutId: number, status: PayoutStatus) =>
    api.patch<PayoutRecord>(`/payouts/${payoutId}`, { status }),
}
